import axios from 'axios'
import { getJWT } from 'src/helper/localStore/getJWT'
import { IsAuthorized } from 'src/authentication/IsAuthorized'
import { objectToQueryString } from 'src/helper/objectToQueryString'

class OperationServices {
  async deleteOperation(externalId: string): Promise<any[]> {
    try {
      const { client_hash }: any = JSON.parse(localStorage.getItem('user') || '{}')

      const res = await axios.put(
        `${process.env.REACT_APP_URL_BUCKET}/operations/set_status/${externalId}/DELETED`,
        {
          headers: {
            'authentication-token': getJWT()!,
            'hash-client': client_hash
          }
        }
      )
      return res.data || {}
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async exportOperation(filter: any): Promise<any[]> {
    try{
      const { client_hash }: any = JSON.parse(localStorage.getItem('user') || '{}')
      const query = objectToQueryString({ ...filter, export: true })
      const url = `${process.env.REACT_APP_URL_BUCKET}/operations/list/?${query}`

      const res = await axios.get(
        url,
        {
          headers: {
            'authentication-token': getJWT()!,
            'hash-client': client_hash
          }
        }
      )
      return res.data || {}
    }catch(error){
      throw error
    }
  }
}
export const operationServices = new OperationServices()